import { buildAgreementsPayloadFromFilter } from '../../../agreements/utils/agreements-filter-payload.builder';
import { validateAgreementsFilterRequest } from '../../../agreements/utils/validate-agreements-filter.util';
import {
    readDwtDefraSubmissionsTaskPaneFilterFromDom,
    validateDwtDefraSubmissionsFilter,
} from '../../../dwt-defra-submissions';
import {
    readDwtPayloadsTaskPaneFilterFromDom,
    validateDwtPayloadsFilter,
} from '../../../dwt-payloads';
import {
    readMaterialSummaryTaskPaneFilterFromDom,
    validateMaterialSummaryPayloadRequest,
} from '../../../material-summary';
import {
    buildMaterialSummaryFilterFromTaskPaneRead,
    buildMaterialSummaryPayloadFromFilter,
} from '../../../material-summary/utils/build-material-summary-payload.util';
import { readAgreementsTaskPaneFilterFromDom } from '../../report-input/read-agreements-taskpane-filter.util';
import {
    REPORT_TARGET_AGREEMENTS_VALUE,
    REPORT_TARGET_DWT_DEFRA_SUBMISSIONS_VALUE,
    REPORT_TARGET_DWT_PAYLOADS_VALUE,
    REPORT_TARGET_MATERIAL_SUMMARY_VALUE,
} from '../../taskpane.constants';

export type ValidateReportFetchDomInputsResult =
    | { readonly ok: true }
    | {
          readonly ok: false;
          readonly message: string;
          readonly invalidElementIds: readonly string[];
      };

/**
 * Mirrors each report fetch handler’s DOM → payload path and the activity-layer validators,
 * so invalid filters are caught before overwrite confirmation or network calls.
 */
export function validateReportFetchDomInputs(targetId: string): ValidateReportFetchDomInputsResult {
    switch (targetId) {
        case REPORT_TARGET_AGREEMENTS_VALUE: {
            const filter = readAgreementsTaskPaneFilterFromDom();
            const payload = buildAgreementsPayloadFromFilter(filter);
            const validation = validateAgreementsFilterRequest(payload);
            if (validation.ok === false) {
                return {
                    ok: false,
                    message: validation.message,
                    invalidElementIds: validation.invalidElementIds,
                };
            }
            return { ok: true };
        }
        case REPORT_TARGET_MATERIAL_SUMMARY_VALUE: {
            const read = readMaterialSummaryTaskPaneFilterFromDom();
            const filter = buildMaterialSummaryFilterFromTaskPaneRead(read);
            const payload = buildMaterialSummaryPayloadFromFilter(filter);
            const validation = validateMaterialSummaryPayloadRequest(payload);
            if (validation.ok === false) {
                return {
                    ok: false,
                    message: validation.message,
                    invalidElementIds: validation.invalidElementIds,
                };
            }
            return { ok: true };
        }
        case REPORT_TARGET_DWT_PAYLOADS_VALUE: {
            const filter = readDwtPayloadsTaskPaneFilterFromDom();
            const validation = validateDwtPayloadsFilter(filter);
            if (validation.ok === false) {
                return {
                    ok: false,
                    message: validation.message,
                    invalidElementIds: validation.invalidElementIds,
                };
            }
            return { ok: true };
        }
        case REPORT_TARGET_DWT_DEFRA_SUBMISSIONS_VALUE: {
            const filter = readDwtDefraSubmissionsTaskPaneFilterFromDom();
            const validation = validateDwtDefraSubmissionsFilter(filter);
            if (validation.ok === false) {
                return {
                    ok: false,
                    message: validation.message,
                    invalidElementIds: validation.invalidElementIds,
                };
            }
            return { ok: true };
        }
        default:
            return { ok: true };
    }
}
